import React, { ComponentProps } from 'react';
import {
  css,
  CSSObject,
  forBrands,
  getFontWeight,
  Theme,
} from '@core-ui/react-stitch';

const brTriggerButtonStyles = (theme: Theme): CSSObject => ({
  '&:hover': {
    backgroundColor: theme.color.b2,
    color: '#ffffff',
  },
  backgroundColor: `${theme.color.b2}00`,
  color: theme.color.inverse.b1,
  textTransform: 'capitalize',
  fontWeight: getFontWeight('book').fontWeight,
});

const baseTriggerButtonCSS = (theme: Theme): CSSObject => ({
  background: 'none',
  border: 'none',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  outline: 'none',
  color: theme.color.b1,
  textTransform: 'uppercase',
  paddingLeft: '0',
  margin: '0.25rem 0',
  '& svg': {
    marginRight: '0.2rem',
  },
});

const nonDashboardTriggerStyles = (theme: Theme): CSSObject => ({
  ...theme.brandFont,
  fontSize: '0.9rem',
  fontWeight: 'bold',
  color: theme.color.b1,
  background: 'none',
  border: 'none',
  margin: '0',
  textTransform: 'uppercase',
  padding: 'unset',
});

const DrawerTrigger = ({
  children,
  openDrawer,
  newDashboard,
}: {
  children: Node[];
  openDrawer: () => void;
  newDashboard: boolean;
}) => {
  const compiledStyles = (theme: Theme) =>
    css({
      ...baseTriggerButtonCSS(theme),
      ...(newDashboard ? {} : nonDashboardTriggerStyles(theme)),
      ...(forBrands(theme, {
        br: () => brTriggerButtonStyles(theme),
        brfs: () => brTriggerButtonStyles(theme),
      }) as CSSObject),
    });
  return (
    <button
      className="filter_button"
      css={compiledStyles}
      id="filterButton"
      onClick={openDrawer}
      type="button"
    >
      {children}
    </button>
  );
};

export default DrawerTrigger;
